// extracted by mini-css-extract-plugin
export default {"mainHeading":"forgotPasswordModal_mainHeading__q0Pfk","container":"forgotPasswordModal_container__SbE15","btn":"forgotPasswordModal_btn__khJNB"};